import React, { useState } from 'react';

// Material UI
import { styled } from '@mui/system';
import { Box, IconButton } from '@mui/material';

// Material UI Icons
import { Fullscreen, FullscreenExit } from '@mui/icons-material';
import { Colortheme } from '../../pages/comman';

// MUI Style
const StyledIconButton = styled(IconButton)`
  && {
    background-color: transparent;
    border: none;
    // padding: 0;
    cursor: pointer;
    height: 42px;
    width: 42px;
  }
`;

const FullScreenDropdown = () => {

    const { inherit } = Colortheme();

    const [fullScr, setFullScr] = useState(false);

    const toggleFullscreen = () => {
        let document: any = window.document;
        setFullScr(!fullScr);

        if (
            !document.fullscreenElement &&
          /* alternative standard method */ !document.mozFullScreenElement &&
            !document.webkitFullscreenElement
        ) {
            // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen();
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }

        // handle fullscreen exit
        const exitHandler = () => {
            if (
                !document.webkitIsFullScreen &&
                !document.mozFullScreen &&
                !document.msFullscreenElement
            )
                document.body.classList.remove("fullscreen-enable");
        };
        document.addEventListener("fullscreenchange", exitHandler);
        document.addEventListener("webkitfullscreenchange", exitHandler);
        document.addEventListener("mozfullscreenchange", exitHandler);
    };
    return (
        <React.Fragment>
            <Box className="header-item" sx={{display:{xs:'none', md:'block', paddingTop:'12px'}}}>
                <StyledIconButton
                    onClick={toggleFullscreen}
                    aria-label="Toggle Fullscreen"
                >
                    {fullScr ? <FullscreenExit sx={{ fontSize: 20, color: inherit }} /> : <Fullscreen sx={{ fontSize: 20 , color: inherit}} />}
                </StyledIconButton>
            </Box>
        </React.Fragment>
    );
};

export default FullScreenDropdown;